import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthSelect", "yearSelect"]
  static values = {
    currentMonthId: Number
  }

  go(event) {
    event.preventDefault()

    const monthNumber = this.monthSelectTarget.value
    const year = this.yearSelectTarget.value

    fetch('/months/travel', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        month: {
          number: monthNumber,
          year: year,
          data: 'false'
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.month_id) {
        window.location.href = `/accounts/overview?month_id=${data.month_id}`
      }
    })
    .catch(error => {
      console.error('Error traveling to month:', error)
    })
  }

  today(event) {
    event.preventDefault()
    window.location.href = `/accounts/overview?month_id=${this.currentMonthIdValue}`
  }
}

